export default __webpack_public_path__ + "static/media/07-participate.8b2e2467.svg";